export default {
    appParams: {
        value: "Значение",
        cancel: "Отменить",
        enterRoleName: "Введите название роли",
    },
    dBase: {
        createBase: "Создать базу",
        bindExistingBase: "Привязать существующую базу",
        server: "Сервер",
        serverNotSelected: "Сервер не выбран",
        base: "База",
        baseNotSelected: "База не выбрана",
        name: "Название",
        shortName: "Короткое название",
        alias: "Алиас",
        comment: "Коментарий",
        baseType: "Тип базы",
        baseTypeNotSelected: "Тип базы не выбран",
        cancel: "Отменить",
        enterBaseName: "Введите имя базы данных",
        enterServer: "Введите сервер",
        enterBaseShortName: "Введите краткое имя базы данных",
        enterBaseType: "Введите тип базы ",
        enterBaseServer: "Введите сервер базы",
        createError: "Ошибка при создании, обратитесь к разработчику",
    },
    form: {
        formName: "Название формы",
        insert: "Добавить",
        edit: "Редактировать",
        server: "сервер",
        app: "приложение",
        dataBase: "базу данных",
        appParam: "параметр приложения",
        user: "пользователя",
        task: "задачу",
        role: "роль"
    },
    param: {
        paramType: "Тип параметра",
        value: "Значение",
        paramTypeNotSelected: "Тип параметра не выбран",
        cancel: "Отменить",
        enterParamType: "Введите тип параметра",
        enterParamValue: "Введите значение параметра",
    },
    role: {
        value: "Значение",
        specialUserChecked: "Особый пользователь",
        cancel: "Отменить",
        enterRoleName: "Введите название роли",
    },
    section: {
        name: "Название",
        alias: "Алиас",
        path: "Путь",
        server: "Сервер",
        serverNotSelected: "Сервер не выбран",
        appType: "Тип приложения",
        appTypeNotSelected: "Тип приложения не выбран",
        appBelongsWeb: "Приложение принадлежит Web",
        cancel: "Отменить",
        enterAppName: "Введите название приложения",
        enterAppPath: "Введите путь приложения",
        enterAppServer: "Введите сервер приложения",
        enterAppType: "Введите тип приложения",
    },
    server: {
        name: "Название",
        serverTypeNotSelected: "Тип сервера не выбран",
        serverType: "Тип сервера",
        pathHttp: "Путь http",
        host: "Хост",
        path: "Путь",
        cancel: "Отменить",
        enterServerName: "Введите название сервера",
        enterServerType: "Введите тип сервера",
        enterServerPathUrl: "Введите путь http сервера",
        enterServerHost: "Введите хост сервера",
        enterServerPath: "Введите путь сервера",
    },
    task: {
        taskName: "Название задачи",
        path: "Путь",
        taskType: "Тип задачи",
        opportunityPickInPackage: "Возможность собирать в пакет",
        comment: "Комментарий",
        cancel: "Отменить",
        enterTaskName: "Введите название задачи",
        enterTaskPath: "Введите путь задачи",
        enterTaskType: "Введите тип задачи",
    },
    user: {
        login: "Логин",
        password: "Пароль",
        fullName: "ФИО",
        expirationDate: "Дата окончания действия",
        role: "Роль",
        blockUser: "Заблокировать пользователя",
        cancel: "Отменить",
        enterUserLogin: "Введите логин пользователя",
        enterUserFullName: "Введите полное имя пользователя",
        enterEndDate: "Введите дату окончания действия",
        enterPassword: "Введите пароль",
        enterRole: "Введите роль",
    },
    errors: {
        notAllRequiredFieldsSelected: "Не все обязательные поля выбраны",
        nameHasSpace: "Не должно содержать пробелов",
    }
}